import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=15a29170&scoped=true"
import script from "./Presupuestos.vue?vue&type=script&lang=js"
export * from "./Presupuestos.vue?vue&type=script&lang=js"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=15a29170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a29170",
  null
  
)

export default component.exports